import { cva } from '@/styled-system/css';

export const showHideButtonRecipe = cva({
  variants: {
    appearance: {
      block: {
        marginBlockStart: '400',
      },
      inline: {},
    },
  },
});
